import Component from "@glimmer/component";
import Box from "glesys-controlpanel/components/box";
import DataLoader from "glesys-controlpanel/components/data-loader";
import Label from "glesys-controlpanel/components/label";
import Select from "glesys-controlpanel/components/select";
import { t } from "ember-intl";
import { on } from "@ember/modifier";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import { action } from "@ember/object";
import { func, string } from "prop-types";
import { arg } from "glesys-controlpanel/utils/arg";
import AlertMessage from "glesys-controlpanel/components/alert-message";
import ENV from "glesys-controlpanel/config/environment";

export default class GpuSelectionBox extends Component {
  @service ajax;
  @service intl;
  @arg(string.isRequired) dataCenter;
  @arg(func.isRequired) onChange;
  @arg(string) selectedGpuType;

  fetchGpuTypesTask = task(async () => {
    const { gputypes } = await this.ajax.request(`${ENV.apiBaseUri}/server/listgputypes?datacenter=${this.dataCenter}`);

    if (!gputypes.length) return [];

    const gpus = gputypes.map((item) => ({ label: item.name, value: item.id, disabled: !item.available }));
    const available = gpus.filter((item) => !item.disabled);
    const unavailable = gpus.filter((item) => item.disabled);

    return [
      { label: this.intl.t("label.no-gpu"), value: "none" },

      { label: this.intl.t("label.available"), options: available },
      { label: this.intl.t("label.unavailable"), options: unavailable },
    ];
  });

  @action
  setGpuType(event) {
    this.onChange(event.target.value === "none" ? null : event.target.value);
  }

  <template>
    <Box data-test-servers-create-gpu-selection-box ...attributes>
      <:header>
        GPU
      </:header>
      <:default>
        <DataLoader @load={{this.fetchGpuTypesTask}} as |gpuTypes|>
          {{#if gpuTypes.length}}
            <div class="grid gap-4 grid-cols-1 lg:grid-cols-2 auto-rows-fr text-base">
              <div>
                <Label for="gpu-type">{{t "label.type"}}</Label>
                <Select
                  id="gpu-type"
                  data-test-select-gpu-type
                  name="gpuType"
                  @items={{gpuTypes}}
                  @value={{@selectedGpuType}}
                  {{on "change" this.setGpuType}}
                />
              </div>
            </div>
          {{else}}
            <AlertMessage data-test-servers-create-gpu-selection-alert-message @type="information">
              {{t "servers.create.gpu-selection-info"}}
            </AlertMessage>
          {{/if}}
        </DataLoader>
      </:default>
    </Box>
  </template>
}
